import BaseViz from './BaseViz'
import ConnectedDotPlot from '../charts/ConnectedDotPlot'
import ConnectedDotPlotDataController from '../viz_behaviors/ConnectedDotPlotDataController'
export default class ConnectedDotPlotViz extends BaseViz {
  static defaultConfig = {
    ItemsHelper: {
      colorScale: {
        value: 'categorical',
        options: ['categorical'],
        nonEditable: true,
      },
    },
    LegendBehavior: {
      showLegend: {
        value: true,
        nonEditable: false,
      },
      icon: 'circle',
    },
    showDatumValues: {
      nonEditable: true,
    },
    AxisHelper: {
      x: {
        showTickValues: {
          nonEditable: true,
        },
      },
    },
  }
  static chartClass = ConnectedDotPlot
  static dataControllerClass = ConnectedDotPlotDataController
}
